/** The widget route. */
export const isEmbedPath = (pathname: string): boolean => /^\/embed(\/|$)/.test(pathname)
